/**
 * Every relation, in one place.
 *
 * `LinkRelation` is the type; this is its runtime enumeration, for the boundaries that have to
 * reject an unrecognised string (the web client's payload normaliser) and for tests that assert
 * a per-relation map is complete.
 *
 * `satisfies` catches a member here that is NOT in the union, but not a union member missing
 * from here. Two things close that gap, both verified by mutation rather than assumed:
 *
 * 1. `LINK_RELATION_LABELS` (`apps/web/src/components/linked-work/relation-labels.ts`) is a
 *    `Record<LinkRelation, string>` in a SOURCE file, so `pnpm typecheck` reads it: a member
 *    added to this union with no phrase fails with TS2741.
 * 2. `relation-labels.test.ts` compares that map's keys against this array at runtime, which is
 *    what catches a phrase added with no entry here.
 *
 * Point 1 has to live in `src/`: the shared, api and web tsconfigs all `exclude` their `tests`
 * directory, so a type-level proof written inside a test file is never checked by `tsc`.
 */
export const LINK_RELATIONS = [
    'created',
    'edited',
    'read',
    'works_on',
    'discusses',
    'linked',
    'uploaded',
    'replaced',
    'viewed',
    'opened',
    'related',
];
export const STRONG_LINK_RELATIONS = [
    'works_on',
    'created',
    'edited',
    'linked',
    'uploaded',
    'replaced',
    'opened',
];
export const WEAK_LINK_RELATIONS = [
    'read',
    'viewed',
    'discusses',
];
export const isLinkRelation = (value) => typeof value === 'string' && LINK_RELATIONS.includes(value);
export const isStrongLinkRelation = (relation) => STRONG_LINK_RELATIONS.includes(relation);
export const isWeakLinkRelation = (relation) => WEAK_LINK_RELATIONS.includes(relation);
//# sourceMappingURL=links.js.map